// The single source of truth for the bulk-meter upload template columns, shared by the
// template writer (buildTemplateWorkbook) and the upload parser (UploadFile). `key` is the
// field name the parser reads; `i18nKey` is the human header label (row 2). group/seq are
// seqwater-only — the same condition the parser uses (ENV.CLIENT_ID === "seqwater").
export type TemplateColumn = { key: string; i18nKey: string };

export const TEMPLATE_TITLE = "BULK METER READ";

const SEQWATER_ONLY: TemplateColumn[] = [
  { key: "group", i18nKey: "bulk_meter_upload.table.group" },
  { key: "seq", i18nKey: "bulk_meter_upload.table.seq" },
];

const BASE_COLUMNS: TemplateColumn[] = [
  { key: "accountNumber", i18nKey: "bulk_meter_upload.table.account_number" },
  { key: "extractionPointName", i18nKey: "bulk_meter_upload.table.extraction_point_name" },
  { key: "serialNo", i18nKey: "bulk_meter_upload.table.meter_serial_no" },
  { key: "reading", i18nKey: "bulk_meter_upload.table.meter_read" },
  { key: "readAt", i18nKey: "bulk_meter_upload.table.date" },
  { key: "note", i18nKey: "bulk_meter_upload.table.note" },
];

export const getTemplateColumns = (isSeqwater: boolean): TemplateColumn[] =>
  isSeqwater ? [...SEQWATER_ONLY, ...BASE_COLUMNS] : BASE_COLUMNS;

export const getTemplateHeaderKeys = (isSeqwater: boolean): string[] =>
  getTemplateColumns(isSeqwater).map(c => c.key);
